import './highlight-card.css';

import React from 'react';
import styled from 'styled-components';

const HighlightCardContainer = styled.div<{ backgroundURL: string }>`
  position: relative;
  border-radius: 0.5rem;
  cursor: pointer;
  ::before {
    content: '';
    position: absolute;
    aspect-ratio: 16 / 9;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
    background-image: url(${({ backgroundURL }) => backgroundURL});
    background-color: black;
    background-size: cover;
    background-clip: border-box;
    opacity: 0.75;
  }
`;

const InsideContainer = styled.div`
  position: relative;
`;

interface HighlightCard extends React.HTMLProps<HTMLButtonElement> {
  backgroundURL?: string;
  status: string;
  title: string;
  subtitle: string;
}

const HighlightCard = ({ backgroundURL, status, subtitle }: HighlightCard) => (
  <HighlightCardContainer className="highlight-card-container" backgroundURL={backgroundURL}>
    <InsideContainer>
      <div className="highlight-card-status">
        <span className="highlight-card-icon-status"></span>
        <p className="highlight-card-text-status">{status}</p>
      </div>
      <h1 className="highlight-card-title">
        {
          'Relacoes alimentares entre os seres vivos + Sistemas agricolas e biodiversidade + Evolução dos seres vivos'
        }
      </h1>
      <h2 className="highlight-card-subtitle">{subtitle}</h2>
    </InsideContainer>
  </HighlightCardContainer>
);

export default HighlightCard;
